import type { EventStatus } from '../components/EventStatus/hooks/useEventStatus';

export const isValidInPlayStatus = (eventStatus: EventStatus) =>
  ['IN_PLAY', 'GOING_IN_PLAY'].includes(eventStatus);
